import { POSTHOG_PROXY_PATH } from "./constants";
import { publicEnv } from "./publicEnv";

interface PosthogConfig {
  /**
   * Whether Argos visual testing should capture PostHog events.
   */
  argosCapture: boolean;

  /**
   * Relative proxy path for CLIENT-SIDE browser requests only.
   *
   * This is a path (not a full URL) that gets resolved by the browser relative
   * to the current domain. It routes through our Next.js proxy to avoid ad-blockers.
   *
   * DO NOT use this for server-side code - it will fail to parse as a URL in Node.js.
   */
  clientProxyPath: string;

  /**
   * The PostHog project API key for the current environment.
   */
  projectKey: string;

  /**
   * Full URL for SERVER-SIDE Node.js requests to PostHog's ingest API.
   *
   * This is an absolute URL that PostHog's Node.js SDK can use directly.
   * Server-side code cannot use relative paths since there's no browser context.
   */
  serverIngestUrl: string;

  /**
   * PostHog's UI host for dashboard links and session replay.
   * Used when linking users to the PostHog dashboard.
   */
  uiHost: string;
}

function getPosthogConfig(): PosthogConfig {
  return {
    argosCapture: true,
    clientProxyPath: POSTHOG_PROXY_PATH,
    projectKey: publicEnv.NEXT_PUBLIC_POSTHOG_KEY,
    serverIngestUrl: "https://us.i.posthog.com",
    uiHost: "https://us.posthog.com",
  };
}

export const posthogConfig = getPosthogConfig();
